import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';

import useAnimate from './primitives/Motion';

import Reveal from './primitives/Reveal';
import WordReveal from './primitives/WordReveal';
import { contact } from '../data/site';

export default function Contact() {
    const ref = useRef(null);
    const reduced = !useAnimate();

    const { scrollYProgress } = useScroll({
        target: ref,
        offset: ['start end', 'end end']
    });

    /* A rise rather than a scale: the glow is an 80px-blurred 1200px surface,
       and scaling it makes the compositor re-rasterise that blur every frame,
       which banded and dropped tiles. Translating a composited layer is free. */
    const glowY = useTransform(scrollYProgress, [0, 1], ['10%', '0%']);
    const glowOpacity = useTransform(scrollYProgress, [0, 0.85], [0, 1]);

    return (
        <section className="section contact" id="contact" ref={ref}>
            {/* `x: '-50%'` has to be handed to framer, not left in CSS: framer
                builds the inline transform from the motion values it is given
                and that string replaces the stylesheet's `translateX(-50%)`
                wholesale, which shunted the glow half its own width to the
                right and clipped it against the section's `overflow: hidden`. */}
            <motion.div
                className="contact__glow"
                style={reduced ? undefined : { x: '-50%', y: glowY, opacity: glowOpacity }}
                aria-hidden="true"
            />

            <div className="shell contact__inner">
                <Reveal y={18}>
                    <span className="t-eyebrow">Start a project</span>
                </Reveal>

                <WordReveal
                    as="h2"
                    className="t-display contact__title"
                    text="Let’s build something smart."
                />

                <Reveal delay={0.14}>
                    <p className="t-lead contact__lead">
                        Tell us what you are building anywhere in South Florida. One
                        conversation covers the power, the systems, and the finishes.
                    </p>
                </Reveal>

                <Reveal delay={0.2} className="contact__actions">
                    <a className="btn btn--solid contact__call" href={contact.phoneHref}>
                        Call {contact.phone}
                    </a>
                </Reveal>

                <Reveal delay={0.26} className="contact__meta">
                    <a href={contact.addressHref} target="_blank" rel="noopener noreferrer">
                        {contact.address}
                    </a>
                </Reveal>
            </div>
        </section>
    );
}
